var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgUnfollow = function SvgUnfollow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Add Friend/Join/ Follow",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon feather-user-check"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5720",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8619",
    d: "M16.485 19.411V17.58a3.663 3.663 0 00-3.663-3.663h-6.41a3.663 3.663 0 00-3.663 3.663v1.831"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8620",
    d: "M13.28 8.252a3.663 3.663 0 11-3.663-3.663 3.663 3.663 0 013.663 3.663z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8622",
    d: "M21.924 10.927l-3.37 3.371"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8623",
    d: "M18.553 14.299l-1.685-1.685"
  })))));
};
export default SvgUnfollow;